import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const accounts = () => import('./accounts-page');
const layout = () => import('./account-layout');
const reconcile = () => import('./reconcile-page');
const accountPages = () => import('./account-pages');
const feeds = () => import('./feeds-pages');

// G3/G4 (g-banking): bank accounts, statement import, reconciliation and Open Banking feeds.
export const routes: RouteObject[] = [
  { path: 'banking', lazy: page(accounts, (m) => m.BankAccountsPage) },
  // Static paths before /banking/:id.
  { path: 'banking/rules', lazy: page(() => import('./rules-page'), (m) => m.BankRulesPage) },
  { path: 'banking/feeds/callback', lazy: page(feeds, (m) => m.FeedCallbackPage) },
  {
    path: 'banking/:id',
    lazy: page(layout, (m) => m.BankAccountLayout),
    children: [
      { index: true, lazy: page(reconcile, (m) => m.ReconcilePage) },
      { path: 'transactions', lazy: page(accountPages, (m) => m.StatementLinesPage) },
      { path: 'statements', lazy: page(accountPages, (m) => m.StatementsPage) },
      { path: 'reconciled', lazy: page(accountPages, (m) => m.ReconciledPage) },
      { path: 'report', lazy: page(accountPages, (m) => m.ReconciliationReportPage) },
    ],
  },
];

export const orgRoutes: RouteObject[] = [];

/** Settings -> Integrations -> Open Banking, mounted by the admin layout. */
export const settingsRoutes: RouteObject[] = [{ path: 'open-banking', lazy: page(feeds, (m) => m.OpenBankingSettingsPage) }];
